<!-- custom-table.component.html -->
<div class="d-flex flex-column w-100 overflow-auto">
  <table
    class="d-flex flex-column bg-white rounded-top fit-content overflow-x-auto w-100"
  >
    <tr
      class="d-flex flex-row align-items-center w-100 p-px-14 border rounded-top"
    >
      @for (column of columns; track column) {
      <th
        class="fs-11 fw-2 text-neutral-dark-grey {{
          column.col ? column.col : column.cellWidth ? '' : 'col'
        }}"
        [ngStyle]="{ width: column.cellWidth }"
      >
        {{ column.header }}
      </th>
      }
    </tr>
    @if (!isLoading) { @for (row of dataSource; track $index) {
    <tr
      class="d-flex align-items-center border-bottom border-start border-end p-px-14"
    >
      @for (column of columns; track column) {
      <td
        class="d-flex flex-column {{
          column.col ? column.col : column.cellWidth ? '' : 'col'
        }}"
        [ngStyle]="{ width: column.cellWidth }"
        (click)="
          column.hasAction &&
            column.actionName &&
            handleRowClick(row, column.actionName)
        "
        [ngClass]="{ 'cursor-pointer': column?.hasAction }"
      >
        <div
          [ngClass]="{ 'cursor-pointer': !column.unClickable }"
          (click)="!column.unClickable && rowClicked(row)"
        >
          <div *ngIf="column.dataType == 'string'">
            <app-title-cell
              [text]="row[column.fieldName]"
              [upperCase]="column.upperCase"
            ></app-title-cell>
          </div>

          <div *ngIf="column.dataType == 'date'">
            <app-date-cell
              [startDate]="
                column.fieldNameStartDate && row[column.fieldNameStartDate]
              "
              [endDate]="
                column.fieldNameEndDate && row[column.fieldNameEndDate]
              "
            ></app-date-cell>
          </div>
          <div *ngIf="column.dataType == 'number'">
            <app-number-cell [data]="row[column.fieldName]"></app-number-cell>
          </div>
          <div *ngIf="column.dataType == 'currency'">
            <app-currency-cell
              [amount]="row[column.fieldName]"
              [currency]="
                column.fieldNameCurrency && row[column.fieldNameCurrency]
              "
            ></app-currency-cell>
          </div>
          <ng-container *ngIf="column.dataType == 'component'">
            <ng-container
              *ngComponentOutlet="
                column.component;
                injector: dynamicComponentInjector();
                inputs: { data: row, column: column }
              "
            ></ng-container>
          </ng-container>
        </div>
      </td>
      }
    </tr>
    } @empty {
    <div class="text-neutral-dark-grey text-center my-px-30">
      Le tableau est actuellement vide.
    </div>
    } } @else {
    <app-loader></app-loader>
    }

    <div
      class="d-flex flex-row align-items-center gap-4 w-100 px-px-14 border-start border-end border-bottom rounded-bottom justify-content-end"
    >
      <div class="custom-paginator">
        <mat-paginator
          #paginator
          [length]="totalItems"
          [pageSize]="pageSize"
          [pageIndex]="pageIndex"
          (page)="nextPage.emit($event)"
          [showFirstLastButtons]="true"
          hidePageSize="true"
        >
        </mat-paginator>
      </div>
    </div>
  </table>
</div>
